import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
export default function login(
  state = { isLoading: false, webtoken: null },
  action
) {
  switch (action.type) {
    case ActionType.WEBNOTIFICATION_SERVICE_ERROR:
      return {
        error: action.hasError,
        message: action.message,
        isLoading: action.isLoading,
      }
    case ActionType.WEBNOTIFICATION_INPROGRESS:
      return {
        ...state,
        isLoading: action.isLoading,
        message: action.message,
      }
    case ActionType.WEBNOTIFICATION_SERVICE_SUCCESS:
      return {
        ...state,
        message: action.message,
        webtoken: action.webtoken,
        isLoading: action.isLoading,
      }
    default:
      return state
  }
}
